// Full millions with one decimal — "8.4", "10.0". Used across the VS
// daily grid, tiles, and any downstream display of tenths-of-a-million
// score values.
export function formatMillionsOneDecimal(tenths: number): string {
  return (tenths / 10).toFixed(1);
}

// Parse a user-typed cell value ("8.4", "9", "10.0") back to tenths.
// Returns null when the input is empty or not a finite number.
export function parseMillionsOneDecimal(raw: string): number | null {
  const s = raw.trim().replace(',', '.');
  if (!s) return null;
  const n = Number(s);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 10);
}

export const DAY_LABELS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;
